import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../Field';
import SubmitInput          from '../Fields/SubmitInput';
import { browserHistory }   from 'react-router';
import FullPageSpinner      from '../Fragments/FullPageSpinner';

// Reusable strings for residence types
let rt1 = 'Letting agent';
let rt2 = 'Solicitor';
let rt3 = 'Landlord';
let Quote = require('../Managers/Quote.js');
let HttpService = require('../Managers/HttpService');
let globalConfig = require('Config');
let envConfig;

class EditLettingReferee extends Component {
    constructor(props) {
        super(props);
        // default to one tenant. do not presume current address provider.
        this.state = {
            tenantNumber: 1,
            areStepQuestionsNeeded: true,
            areRentFrequencyQuestionsNeeded: null,
            isPaymentFrequencyMonthly: null,
            isPaymentFrequencyWeekly: null,
            isPaymentFrequencyOther: null,
            rentalAmountLabel: 'How much is your current rent?',
            isForeignAddress: false,
            isLoading: true,
            isFullPageSpinnerActive: false,
        };
        this.inputComponents = [];
    }

    componentWillMount() {
        window.localStorage.clear();
        let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if ( ! this.props.params.tokenId || ! uuidFormat.test(this.props.params.tokenId)) {
            // No token = error page
            browserHistory.push('/error/no-auth');
            return false;
        }
        this.getData();

        // Set all the legal texts - inject relevant ones to the footer.
        HttpService.getPrivateLegalTexts(this.props.params.tokenId)
        .then(() => {
            document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
        })
        .catch(error => {
            throw error;
        });

        envConfig = HttpService.getConfigForHost();
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    getData() {
        HttpService.getRetrieveLettingReferee(this.props.params.tokenId).then(data => {
            window.localStorage.setItem('EmploymentLettingReferee', JSON.stringify(data));
            this.setState({
                isLoading: false,
            });
        });
    }

    saveLettingReferee() {
        this.setState({ isFullPageSpinnerActive: true });
        HttpService.postSaveLettingReferee(this.props.params.tokenId).then(() => {
            this.setState({ isFullPageSpinnerActive: false });
            window.location.replace(envConfig.tatLanding.url);
        });
    }

    handleChildUpdate(v) {
        switch(v) {
            case 1:
                this.setState({ residenceType: rt1 });
                break;
            case 2:
                this.setState({ residenceType: rt2 });
                break;
            default:
                this.setState({ residenceType: rt3 });
                break;
        }
        this.setState({areRentFrequencyQuestionsNeeded:true});
    }

    handleRentFrequency(v) {
        switch(v) {
            case 1: // weekly
                this.setState({
                    isPaymentFrequencyMonthly: false,
                    isPaymentFrequencyWeekly: true,
                    isPaymentFrequencyOther: false,
                    rentalAmountLabel: 'How much is your current weekly rent?'
                });
                break;
            case 2: // 4-weekly
                this.setState({
                    isPaymentFrequencyMonthly: false,
                    isPaymentFrequencyWeekly: false,
                    isPaymentFrequencyOther: false,
                    rentalAmountLabel: 'How much rent do you currently pay every 4 weeks?'
                });
                break;
            case 3: // monthly
                this.setState({
                    isPaymentFrequencyMonthly: true,
                    isPaymentFrequencyWeekly: false,
                    isPaymentFrequencyOther: false,
                    rentalAmountLabel: 'How much is your current monthly rent?'
                });
                break;
            default:
                this.setState({
                    isPaymentFrequencyMonthly: false,
                    isPaymentFrequencyWeekly: false,
                    isPaymentFrequencyOther: true,
                });
                break;
        }
    }

    // todo: gross manual step transitions until we have a step manager
    manualStepProgression() {
        this.inputComponents.filter(value => {
            return (value !== null) && (value !== undefined);
        }).map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                this.saveLettingReferee();
            }
        }, 1000);
    }

    isForeignAddress(v) {
        this.setState({ isForeignAddress: v });
    }

    render() {
        let t = '-tenant' + this.state.tenantNumber;
        return(
            <div>
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                { this.state.isLoading === true ?
                    <div className="loading">
                        <div className="spinner">
                            <p><strong>Loading...</strong></p>
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                        </div>
                    </div>
                :
                    <div>
                    <question-row class="no-border">
                        <h1>Edit residential status</h1>
                    </question-row>

                    <div>
                        <Field
                            question="Who do you currently rent your property through?"
                            fieldName={'residenceType' + t}
                            storageKey="type"
                            type="button-choice"
                            options={[
                                {
                                    value: globalConfig.lettingRefereeTypes.LETTING_ESTATE_AGENT,
                                    text: rt1
                                },
                                {
                                    value: globalConfig.lettingRefereeTypes.SOLICITOR,
                                    text: rt2
                                },
                                {
                                    value: globalConfig.lettingRefereeTypes.LANDLORD,
                                    text: rt3
                                }
                            ]}
                            callbackFunction={this.handleChildUpdate.bind(this)}
                            dataValidation="required_field"
                            source="EmploymentLettingReferee"
                            loadingKey={'EmploymentLettingReferee.type'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        {this.state.residenceType ?
                            <div>
                                <Field
                                    fieldName={'residenceName' + t}
                                    question={this.state.residenceType + ' name'}
                                    storageKey="name"
                                    type="text"
                                    dataValidation="required_field"
                                    maxLength={60}
                                    source="EmploymentLettingReferee"
                                    loadingKey={'EmploymentLettingReferee.name'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                                <Field
                                    type="address"
                                    fieldName={this.state.residenceType + '_' + t}
                                    question={this.state.residenceType + ' address'}
                                    storageKey="address"
                                    addressOptions={{
                                        canHaveManualEntry: true,
                                        canBeForeign: true,
                                        pafLookup: true,
                                        hasManualEntryOption:true,
                                    }}
                                    callbackFunction={this.isForeignAddress.bind(this)}
                                    source="EmploymentLettingReferee.address"
                                    loadingKey={'EmploymentLettingReferee.address'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                                {this.state.isForeignAddress === false ?
                                    <Field
                                        type="text"
                                        maxLength={11}
                                        fieldName={'residenceMobile' + t}
                                        question={this.state.residenceType + ' mobile number (UK only)'}
                                        storageKey="mobile"
                                        dataValidation="mobile_number.non_mandatory"
                                        helpText={'Providing a mobile number for your ' + this.state.residenceType.toLowerCase() + ' can help speed up the application process.'}
                                        source="EmploymentLettingReferee"
                                        loadingKey={'EmploymentLettingReferee.mobile'}
                                        loadValues={true}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}
                                <Field
                                    type="email"
                                    fieldName={'residenceEmail' + t}
                                    question={this.state.residenceType + ' email address'}
                                    storageKey="email"
                                    dataValidation="email_address.non_mandatory"
                                    source="EmploymentLettingReferee"
                                    loadingKey={'EmploymentLettingReferee.email'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                                <Field
                                    type="text"
                                    maxLength={20}
                                    fieldName={'residencePhone' + t}
                                    question={this.state.residenceType + ' telephone number'}
                                    storageKey="phone"
                                    dataValidation="phone_number"
                                    source="EmploymentLettingReferee"
                                    loadingKey={'EmploymentLettingReferee.phone'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                            </div>
                        : null}

                        {this.state.areRentFrequencyQuestionsNeeded === true ?
                            <Field
                                fieldName={'residenceRentalFrequency' + t}
                                question="How frequently do you pay your rent?"
                                storageKey="paymentFrequency"
                                type="button-choice"
                                options={[
                                    {
                                        value: globalConfig.lettingRefereePaymentFrequencies.MONTHLY,
                                        text: 'Monthly'
                                    },
                                    {
                                        value: globalConfig.lettingRefereePaymentFrequencies.FOUR_WEEKLY,
                                        text: '4 weekly'
                                    },
                                    {
                                        value: globalConfig.lettingRefereePaymentFrequencies.WEEKLY,
                                        text: 'Weekly'
                                    },
                                    {
                                        value: globalConfig.lettingRefereePaymentFrequencies.ALL_IN_ONE,
                                        text: 'Full amount in advance'
                                    },
                                    {
                                        value: globalConfig.lettingRefereePaymentFrequencies.OTHER,
                                        text: 'Other'
                                    }
                                ]}
                                callbackFunction={this.handleRentFrequency.bind(this)}
                                dataValidation="required_field"
                                source="EmploymentLettingReferee"
                                loadingKey={'EmploymentLettingReferee.paymentFrequency'}
                                loadValues={true}
                                ref={(instance) => {this.inputComponents.push(instance);}}
                            />
                        : null}

                        {this.state.isPaymentFrequencyOther === false ?
                            <div>
                                <Field
                                    type="money"
                                    fieldName={'residenceRentAmount' + t}
                                    question={this.state.rentalAmountLabel}
                                    storageKey="paymentAmount"
                                    dataValidation="required_field"
                                    source="EmploymentLettingReferee"
                                    loadingKey={'EmploymentLettingReferee.paymentAmount'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />

                                {this.state.isPaymentFrequencyMonthly === true ?
                                    <Field
                                        fieldName={'residenceRentDate' + t}
                                        question="What date is your rent due each month?"
                                        storageKey="paymentDayOfMonth"
                                        type="date"
                                        subType="day"
                                        dataValidation="required_field"
                                        source="EmploymentLettingReferee"
                                        loadingKey={'EmploymentLettingReferee.paymentDayOfMonth'}
                                        loadValues={true}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}

                                {this.state.isPaymentFrequencyWeekly === true ?
                                    <Field
                                        fieldName={'residenceRentDate' + t}
                                        question="What day is your rent due?"
                                        storageKey="paymentDayOfWeek"
                                        type="date"
                                        subType="day-of-the-week"
                                        dataValidation="required_field"
                                        source="EmploymentLettingReferee"
                                        loadingKey={'EmploymentLettingReferee.paymentDayOfWeek'}
                                        loadValues={true}
                                        ref={(instance) => {this.inputComponents.push(instance);}}
                                    />
                                : null}

                                <Field
                                    fieldTitle="Fast Track"
                                    question="You can help reduce the time it takes to complete your reference by providing us with evidence of your rental payments."
                                    fieldName={'residenceEvidence' + t}
                                    storageKey="upload"
                                    type="upload"
                                    contextInfo={'Residence evidence'}
                                    allowFileUploads={true}
                                    allowCameraUploads={true}
                                    helpText={'<p>For this reference suitable documents are:</p><ul><li>A copy of the tenancy agreement and last 6 months bank statements showing rent being paid</li><li>A copy of the tenancy agreement and rental statement covering the last 6 months</li></ul>'}
                                    source="EmploymentLettingReferee"
                                />
                            </div>
                        : null}
                    </div>
                    </div>
                }



                <SubmitInput
                    label="Edit Details"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={true}
                    backLinkText={"Cancel"}
                    backLinkUrl={envConfig.tatLanding.url}
                    currentNumber={3}
                />
            </div>
        );
    }
}

EditLettingReferee.propTypes = {
    params: PropTypes.object,
};

export default EditLettingReferee;


// WEBPACK FOOTER //
// ./src/components/Screens/EditLettingReferee.js